module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('div', {
    staticClass: "title-acknowPage"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429932950_toc01#toctitle1",
      "id": "title1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "u"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgments")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("I")]), _vm._v(" want to acknowledge the invaluable assistance of my I research assistant, Zack Hughes, Princeton ’08, who helped me pull together a lot of the background information on the espionage cases cited in Part One, and checked facts in other parts of the manuscript. He was a volunteer for the enterprise and justified my confidence in his abilities. I hope to see him in public service one day.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I also acknowledge the helpful prodding and advice I received from Mark LaFlaur, senior editor at Thomas Dunne Books, who made numerous constructive suggestions on ways to reorder, amplify points, and otherwise tighten up the manuscript during its preparation. Both he and Tom Dunne have made it a better book.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7650070c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429932950_ack01.vue
// module id = 69
// module chunks = 0